import Vue from 'vue'
import VueI18n from 'vue-i18n'

import en from 'vuetify/lib/locale/en'
import tr from 'vuetify/lib/locale/tr'

Vue.use(VueI18n)

const messages = {
  en: {
    ...require('@/locales/en.json'),
    $vuetify: en,
  },
  tr: {
    ...require('@/locales/tr.json'),
    $vuetify: tr,
  },
}

export default new VueI18n({
  locale: localStorage.getItem("i18n-language") || navigator.language.split('-')[0],
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages,
})
